import React from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import ContentIcon from '../ContentIcon/index.js';
import ProgressBar from '../ProgressBar/index.js';
import calcProgress from '../lib/calcProgress.js';
import s from '../lib/composeLabels.js';
import TimeLeft from '../lib/time/TimeLeft.js';
import TotalTime from '../lib/time/TotalTime.js';

const ContentProgressSummary = ({
  content,
  user,
  labels,
  locks
}) => {
  const progress = calcProgress(user, content);
  const renderUnauthenticated = () => {
    if (user) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "slds-m-top_x-small"
    }, content.estimatedTime);
  };
  const renderProgress = () => {
    if (!user) {
      return null;
    }
    if (user.finishedAt) {
      return null;
    }
    if (progress === 100) {
      return null;
    }
    const showTimeLeft = user.estimatedTime && progress > 0 && progress < 100;
    const showTotalTime = content.estimatedTime && !showTimeLeft;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "slds-grid slds-grid_align-center slds-m-vertical_x-small"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: "7rem"
      }
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      value: progress,
      labels: {
        progress: s(labels.progress, {
          n: progress
        })
      }
    }))), /*#__PURE__*/React.createElement("div", null, showTimeLeft && /*#__PURE__*/React.createElement(TimeLeft, {
      estimatedTime: user.estimatedTime
    }), showTotalTime && /*#__PURE__*/React.createElement(TotalTime, {
      totalTime: content.estimatedTime
    }), /*#__PURE__*/React.createElement("span", null, progress, "%")));
  };
  const renderCompleted = () => {
    if (!user) {
      return null;
    }
    const unfinishedModule = content.type !== "trail" && !user.finishedAt;
    const unfinishedTrail = content.type === "trail" && progress !== 100;
    if (unfinishedModule || unfinishedTrail) {
      return null;
    }
    const label = content.type === "trail" && progress === 100 ? labels.unitCompleted : s(labels.completed, {
      date: user.finishedAt
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "slds-m-top_x-small"
    }, label);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "12rem"
    },
    className: "slds-text-align_center slds-text-body_small tds-color_meteorite"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slds-grid slds-grid_align-center"
  }, /*#__PURE__*/React.createElement(ContentIcon, {
    content: {
      ...pick(content, ["color", "image", "type", "unitCount"])
    },
    user: pick(user, ["finishedAt", "unlocked", "completedCount"]),
    noLink: true,
    locks: locks
  })), renderUnauthenticated(), renderProgress(), renderCompleted());
};
ContentProgressSummary.displayName = "ContentProgressSummary";
ContentProgressSummary.defaultProps = {
  user: null,
  locks: true
};
const {
  bool,
  number,
  oneOf,
  shape,
  string
} = PropTypes;
ContentProgressSummary.propTypes = {
  /**
   * Labels for l10n.
   */
  labels: shape({
    completed: string.isRequired,
    progress: string.isRequired
  }).isRequired,
  /**
   * Content information. Does not include progress information.
   */
  content: shape({
    color: string,
    image: string.isRequired,
    type: oneOf(["trail", "module", "project", "trailmix", "customstep", "superbadge", "credential"]).isRequired,
    estimatedTime: string,
    unitCount: number
  }).isRequired,
  /**
   * User and progress information.
   */
  user: shape({
    completedCount: number,
    estimatedTime: string,
    finishedAt: string
  }),
  /**
   * Whether to use lock icons, or not.
   */
  locks: bool
};
var ContentProgressSummary$1 = ContentProgressSummary;

export { ContentProgressSummary$1 as default };
